import { planningAPI } from "../../axios";

export const actions = {
    // PlanningModeOfVerification
    GetTemplateMOVByTarget(context, data){
        return planningAPI.get(`PlanningTemplateModeOfVerification/PlanningTemplateMainTarget/${data}`);
    },
    GetSingleTemplateMOV(context, data){
        return planningAPI.get(`PlanningTemplateModeOfVerification/${data}`);
    },
    CreateTemplateMOV(context, data){
        return planningAPI.post(`PlanningTemplateModeOfVerification/AddPlanningTemplateModeofVerification`, data);
    },
    UpdateTemplateMOV(context, data){
        return planningAPI.put(`PlanningTemplateModeOfVerification/${data.id}`, data);
    },
    DeleteTemplateMOV(context, data){
        return planningAPI.delete(`PlanningTemplateModeOfVerification/${data}`);
    },
}
